import {Navigate, Outlet} from "react-router-dom";


export const RouteGuard = ({children}) => {
    const persistedStateSerialized = localStorage.getItem('auth');
    let persistedState = {}
    if (persistedStateSerialized) {
        persistedState = JSON.parse(persistedStateSerialized);
    }
    if (!persistedState.token) {
        return <Navigate to="/login"/>;
    }



    return children ? children : <Outlet/>
}